export const EVENT_MGMT_TAB_EVENTS = "events";
export const EVENT_MGMT_TAB_PARTICIPANTS = "participants";
export const EVENT_MGMT_TAB_PARTICIPANTS_DETAILS = "participantsDetails";
export const EVENT_MGMT_TAB_CLOSE_RECORD = "closeRecord";
export const EVENT_MGMT_VALID_TABS = [
  EVENT_MGMT_TAB_EVENTS,
  EVENT_MGMT_TAB_PARTICIPANTS,
  EVENT_MGMT_TAB_PARTICIPANTS_DETAILS,
  EVENT_MGMT_TAB_CLOSE_RECORD,
];
export const EVENT_MGMT_DEFAULT_TAB = EVENT_MGMT_TAB_EVENTS;

/** Route guard: any of these permissions grants access to `/Events`. */
export const EVENT_MGMT_ROUTE_PERMISSIONS = [
  "menu.events",
  "menu.event_participants",
  "menu.event_participant_profiles",
  "menu.close_event_record",
];

export const EVENT_MGMT_TAB_PERMISSIONS = {
  [EVENT_MGMT_TAB_EVENTS]: "menu.events",
  [EVENT_MGMT_TAB_PARTICIPANTS]: "menu.event_participants",
  [EVENT_MGMT_TAB_PARTICIPANTS_DETAILS]: "menu.event_participant_profiles",
  [EVENT_MGMT_TAB_CLOSE_RECORD]: "menu.close_event_record",
};

export function getPermittedEventManagementTabs(hasPermission) {
  return EVENT_MGMT_VALID_TABS.filter((tab) =>
    hasPermission(EVENT_MGMT_TAB_PERMISSIONS[tab])
  );
}

export function getDefaultEventManagementTab(hasPermission) {
  const permitted = getPermittedEventManagementTabs(hasPermission);
  return permitted[0] || EVENT_MGMT_DEFAULT_TAB;
}

/** Build `/Events?…` with tab and optional query params (values omitted when null/empty). */
export function buildEventsManagementPath(params = {}) {
  const { tab = EVENT_MGMT_DEFAULT_TAB, ...rest } = params;
  const sp = new URLSearchParams();
  sp.set("tab", tab);
  for (const [key, value] of Object.entries(rest)) {
    if (value != null && value !== "") sp.set(key, String(value));
  }
  return `/Events?${sp.toString()}`;
}

/** Preserve legacy query/path params when redirecting old standalone routes to `/Events`. */
export function buildEventsManagementLegacyRedirectPath(
  tab,
  { search = "", pathParams = {} } = {}
) {
  const incoming = Object.fromEntries(new URLSearchParams(search));
  return buildEventsManagementPath({ tab, ...incoming, ...pathParams });
}
